import { render, staticRenderFns } from "./warehouseSettingsDetail.vue?vue&type=template&id=dd8d6a0e&scoped=true"
import script from "./warehouseSettingsDetail.vue?vue&type=script&lang=js"
export * from "./warehouseSettingsDetail.vue?vue&type=script&lang=js"
import style0 from "./warehouseSettingsDetail.vue?vue&type=style&index=0&id=dd8d6a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8d6a0e",
  null
  
)

export default component.exports